import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {useDataValue} from 'globals/contexts/dataContext';

const ScrollToTop = () => {
  const [{currentLanguage, currentPage}, dispatch] = useDataValue();
  const history = useHistory();
  const transitionTimer = useRef(null);
  useEffect(() => {
    const unlisten = history.listen(() => {
      if (history.action === "REPLACE") {

      } else {
        // debugger;
        if (transitionTimer.current) {
          clearTimeout(transitionTimer.current);
        }
        dispatch({
          type: 'pageTransitionStart',
        });
        transitionTimer.current = setTimeout(() => {
          window.scrollTo(0, 0);
          dispatch({
            type: 'pageTransitionEnd',
          });
        }, 1000);
      }
    });
    return () => {
      unlisten();
    }
  }, [history]);
  return (null);
}

export default ScrollToTop;